import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Banner } from "@similarweb/ui-components";

import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, blue } = colorsPalettes;

export const BannerWrapper = styled(CenteredFlexColumn)`
    align-items: flex-end;
`;

export const IconWrapper = styled.span`
    padding: 2px;
    border-radius: 100%;
    background: ${blue[400]};

    & .SWReactIcons {
        display: flex;
        align-items: center;

        height: 12px;
        width: 12px;
    }
`;

export const StyledBanner = styled(Banner)`
    padding: 8px 12px;
    background: ${blue[100]};

    .benchmarkMetricBannerTitle {
        ${setFontVariant("body2")};
        color: ${carbon[400]};
    }

    div:has(> .benchmarkMetricBannerTitle) {
        margin-left: 8px;
    }
`;
